module.exports = __webpack_public_path__ + "img/7_88.b64b576a.png";